import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

let scrollRestorationDisabled = false;

/**
 * Scroll the window to the absolute top.
 * Do NOT use scrollIntoView — with a fixed navbar, block:"start" tucks the
 * first content (e.g. Back button) under the header.
 */
export function scrollPageToTop(_anchor?: HTMLElement | null) {
  if (
    !scrollRestorationDisabled &&
    "scrollRestoration" in window.history
  ) {
    window.history.scrollRestoration = "manual";
    scrollRestorationDisabled = true;
  }

  window.scrollTo(0, 0);
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}

/**
 * Scroll to top now and again after layout/paint (images, late content).
 * Returns a cleanup that clears pending timeouts.
 */
export function scheduleScrollToTop(
  anchor?: HTMLElement | null,
  delaysMs: number[] = [0, 50, 150, 300, 500, 800],
) {
  scrollPageToTop(anchor);

  const timeoutIds = delaysMs.map((delay) =>
    window.setTimeout(() => scrollPageToTop(anchor), delay),
  );

  const raf1 = requestAnimationFrame(() => {
    scrollPageToTop(anchor);
    requestAnimationFrame(() => scrollPageToTop(anchor));
  });

  return () => {
    cancelAnimationFrame(raf1);
    timeoutIds.forEach((id) => window.clearTimeout(id));
  };
}

export function useScrollToTop(deps: unknown[] = []) {
  const { pathname, key } = useLocation();

  useLayoutEffect(() => {
    return scheduleScrollToTop();
  }, [pathname, key, ...deps]);
}

const ScrollToTop = () => {
  useScrollToTop();
  return null;
};

export default ScrollToTop;
